export default __webpack_public_path__ + "static/media/grafema_illustrations-ua-campaign_01.153d3f89.jpg";